import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/buttonScrollingModal';

export const BUTTON_SCROLLING_MODAL_BUTTON_VIEW = `${rootActionPath}/Button/View`;
export const BUTTON_SCROLLING_MODAL_LOGOS_GET_SUCCESS = `${rootActionPath}/Logos/GET_${SUCCESS_SUFFIX}`;
export const BUTTON_SCROLLING_MODAL_LOGOS_GET_FAILURE = `${rootActionPath}/Logos/GET_${FAILURE_SUFFIX}`;
